export default [
  {
    id: "mara",
    exchange: "NASDAQ",
    symbol: "MARA",
    name: "Marathon Digital Holdings, Inc.",
    label: "Mara",
    website: "https://marathondh.com/",
    img: "mara.png"
  },
  {
    id: "riot",
    exchange: "NASDAQ",
    symbol: "RIOT",
    name: "Riot Blockchain, Inc.",
    label: "Riot",
    website: "https://www.riotblockchain.com/",
    img: "riot.png"
  },
  {
    id: "hut8",
    exchange: "NASDAQ",
    symbol: "HUT",
    name: "Hut 8 Mining Corp.",
    label: "Hut8",
    website: "https://hut8mining.com/",
    img: "hut8.jpg"
  },
  {
    id: "bitf",
    exchange: "NASDAQ",
    symbol: "BITF",
    name: "Bitfarms Ltd.",
    label: "Bitfarms",
    website: "https://bitfarms.com/",
    img: "bitf.jpg"
  },
  {
    id: "hive",
    exchange: "NASDAQ",
    symbol: "HVBT",
    name: "HIVE Blockchain Technologies Ltd.",
    label: "Hive",
    website: "https://www.hiveblockchain.com/",
    img: "hive.jpg"
  },
  {
    id: "argo",
    exchange: "NASDAQ",
    symbol: "ARBKF",
    name: "Argo Blockchain plc",
    label: "Argo",
    website: "https://argoblockchain.com/",
    img: "argo.jpg"
  },
  {
    id: "btbt",
    exchange: "NASDAQ",
    symbol: "BTBT",
    name: "Bit Digital, Inc.",
    label: "Bit Digital",
    website: "https://bit-digital.com/",
    img: "btbt.png"
  },
  {
    id: "hsshf",
    exchange: "NASDAQ",
    symbol: "HSSHF",
    name: "Digihost Technology Inc.",
    label: "Digihost",
    website: "https://digihost.ca/",
    img: "hsshf.png"
  }
]
